var _this = this,
  _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB-JOB1/src/components/Button/Button.js";
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n          min-width: ", ";\n          min-height: ", ";\n          padding:", ";\n          fontSize:", ";\n        "]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import styled, { css } from 'styled-components';
import { Transition } from 'react-transition-group';
import loadingAnimation from '@dls/assets/lottiefiles/loading';
import tickAnimation from '@dls/assets/lottiefiles/tick';
import { withTheme, useTheme } from '../../core/ThemeProvider';
import Animation from '../Animation';
import Text from '../Text';
import { Fade } from './animation';
import Config from '../../config';
var buttonStatus = {
  FAILURE: 'failure',
  SUCCESS: 'success',
  IN_PROGRESS: 'inProgress'
};
var renderContent = function renderContent(loading, text) {
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Transition, {
    timeout: FADE_DURATION,
    "in": !loading,
    mountOnEnter: true,
    unmountOnExit: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 7
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(Fade, {
      state: state,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Text, {
      type: "boldBody",
      lineHeight: "compact",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34,
        columnNumber: 13
      }
    }, text));
  }), /*#__PURE__*/React.createElement(Transition, {
    timeout: FADE_DURATION,
    "in": loading === buttonStatus.FAILURE,
    mountOnEnter: true,
    unmountOnExit: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 7
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(Overlay, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Fade, {
      state: state,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Text, {
      type: "boldBody",
      lineHeight: "compact",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 49,
        columnNumber: 15
      }
    }, text)));
  }), /*#__PURE__*/React.createElement(Transition, {
    timeout: 0,
    "in": loading === buttonStatus.SUCCESS,
    mountOnEnter: true,
    unmountOnExit: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(Overlay, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Fade, {
      state: state,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Animation, {
      source: tickAnimation,
      size: "24px",
      color: theme.cl_white,
      action: "play",
      loop: false,
      segments: [28, 60],
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 15
      }
    })));
  }), /*#__PURE__*/React.createElement(Transition, {
    timeout: FADE_DURATION,
    "in": loading === buttonStatus.IN_PROGRESS,
    mountOnEnter: true,
    unmountOnExit: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 7
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(Overlay, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Fade, {
      state: state,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 85,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Animation, {
      source: loadingAnimation,
      size: "24px",
      color: theme.cl_white,
      action: "play",
      loop: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 86,
        columnNumber: 15
      }
    })));
  }));
};
var Button = function Button(props) {
  var text = props.text,
    type = props.type,
    id = props.id,
    href = props.href,
    target = props.target,
    small = props.small,
    large = props.large,
    title = props.title,
    secondary = props.secondary,
    link = props.link,
    outline = props.outline,
    disabled = props.disabled,
    loading = props.loading,
    fullWidth = props.fullWidth,
    onClick = props.onClick,
    children = props.children,
    customStyle = props.customStyle,
    rest = _objectWithoutProperties(props, ["text", "type", "id", "href", "target", "small", "large", "title", "secondary", "link", "outline", "disabled", "loading", "fullWidth", "onClick", "children", "customStyle"]);
  var handleClick = function handleClick(e) {
    if (!disabled && onClick) {
      return onClick(e);
    }
  };
  var loadingStatus = !secondary && loading;
  var buttonType = secondary ? 'secondary' : link ? 'link' : 'primary';
  var buttonSize = small ? 'small' : large ? 'large' : 'medium';
  return /*#__PURE__*/React.createElement(ButtonWrapper, {
    loadingStatus: loadingStatus,
    type: type,
    id: id,
    href: href,
    target: target,
    title: title,
    buttonType: buttonType,
    buttonSize: buttonSize,
    outline: outline,
    disabled: disabled,
    fullWidth: fullWidth,
    onClick: handleClick,
    "data-testid": rest['data-testid'],
    customStyle: customStyle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 5
    }
  }, renderContent(loadingStatus, text || children));
};
Button.defaultProps = {
  type: 'button',
  disabled: false,
  secondary: false,
  link: false,
  loading: false,
  small: false,
  large: false,
  customStyle: {}
};
var FADE_DURATION = 200;
var Overlay = styled.div.withConfig({
  displayName: "Button__Overlay",
  componentId: "sc-1d9pl1z-0"
})(["position:absolute;left:0;top:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;"]);
var ButtonWrapper = withTheme(styled.button.withConfig({
  displayName: "Button__ButtonWrapper",
  componentId: "sc-1d9pl1z-1"
})(function (_ref) {
  var _coreTheme$button$sec, _coreTheme$button$sec2, _coreTheme$button$sec3, _coreTheme$button$sec4, _coreTheme$button$sec5, _coreTheme$button$sec6, _coreTheme$button$lin, _coreTheme$button$lin2, _coreTheme$button$lin3, _coreTheme$button$sec7, _coreTheme$button$sec8, _coreTheme$button$dis, _coreTheme$button$dis2, _coreTheme$button$dis3;
  var coreTheme = _ref.coreTheme,
    fullWidth = _ref.fullWidth,
    buttonType = _ref.buttonType,
    buttonSize = _ref.buttonSize,
    outline = _ref.outline,
    loadingStatus = _ref.loadingStatus,
    customStyle = _ref.customStyle;
  return css(["&&&{background-color:", ";box-sizing:border-box;cursor:pointer;display:inline-block;height:auto;outline:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border:", ";min-width:", ";min-height:", ";border-radius:", ";padding:", ";margin:0;position:relative;text-align:center;text-decoration:none;line-height:normal;transition:background-color 0.1s ease-in;width:", ";transition-delay:0s;p{color:", ";font-family:", ";font-size:", ";font-weight:", ";}&:hover{background-color:", ";p{color:", ";}}&:active{background-color:", ";}", ";", ";", ";", ";", ";&[disabled]{cursor:default;pointer-events:none;background-color:", ";border-color:", ";p{color:", ";}}", ";", ";", ";}"], coreTheme.button.background, coreTheme.button.border, coreTheme.button.minWidth, coreTheme.button.minHeight, coreTheme.button.borderRadius, coreTheme.button.padding, fullWidth ? '100%' : 'auto', coreTheme.cl_white, coreTheme.button.fontFamily, coreTheme.button.fontSize, coreTheme.button.fontWeight, coreTheme.button.hoverBg, coreTheme.button.hoverColor, coreTheme.button.activeBg, coreTheme.button[buttonSize] && css(["min-width:", ";min-height:", ";padding:", ";border-width:", ";p{font-size:", ";}"], coreTheme.button[buttonSize].minWidth, coreTheme.button[buttonSize].minHeight, coreTheme.button[buttonSize].padding, coreTheme.button[buttonSize].borderWidth, coreTheme.button[buttonSize].fontSize), buttonType === 'secondary' && coreTheme.button.secondary && css(["background-color:", ";border-color:", ";p{color:", ";}&:hover{background-color:", ";border-color:", ";p{color:", ";}}&:active{background-color:", ";}"], (_coreTheme$button$sec = coreTheme.button.secondary) === null || _coreTheme$button$sec === void 0 ? void 0 : _coreTheme$button$sec.background, (_coreTheme$button$sec2 = coreTheme.button.secondary) === null || _coreTheme$button$sec2 === void 0 ? void 0 : _coreTheme$button$sec2.borderColor, (_coreTheme$button$sec3 = coreTheme.button.secondary) === null || _coreTheme$button$sec3 === void 0 ? void 0 : _coreTheme$button$sec3.color, (_coreTheme$button$sec4 = coreTheme.button.secondary) === null || _coreTheme$button$sec4 === void 0 ? void 0 : _coreTheme$button$sec4.hoverBg, (_coreTheme$button$sec5 = coreTheme.button.secondary) === null || _coreTheme$button$sec5 === void 0 ? void 0 : _coreTheme$button$sec5.hoverBorderColor, (_coreTheme$button$sec6 = coreTheme.button.secondary) === null || _coreTheme$button$sec6 === void 0 ? void 0 : _coreTheme$button$sec6.hoverColor, coreTheme.button.secondary.activeBg), buttonType === 'link' && coreTheme.button.link && css(["background:transparent;border:none;min-width:auto;min-height:auto;align-self:start;padding:0;p{color:", ";font-family:", ";}&:hover{p{color:", ";}}"], (_coreTheme$button$lin = coreTheme.button.link) === null || _coreTheme$button$lin === void 0 ? void 0 : _coreTheme$button$lin.color, (_coreTheme$button$lin2 = coreTheme.button.link) === null || _coreTheme$button$lin2 === void 0 ? void 0 : _coreTheme$button$lin2.fontFamily, (_coreTheme$button$lin3 = coreTheme.button.link) === null || _coreTheme$button$lin3 === void 0 ? void 0 : _coreTheme$button$lin3.hoverColor), outline && coreTheme.button.outline && css(["&,&:hover{background-color:transparent;border-color:", ";p{color:", ";}}"], buttonType === 'secondary' ? (_coreTheme$button$sec7 = coreTheme.button.secondary) === null || _coreTheme$button$sec7 === void 0 ? void 0 : _coreTheme$button$sec7.background : coreTheme.button.background, buttonType === 'secondary' ? (_coreTheme$button$sec8 = coreTheme.button.secondary) === null || _coreTheme$button$sec8 === void 0 ? void 0 : _coreTheme$button$sec8.background : coreTheme.button.background), customStyle && coreTheme.button.customStyle && css(["background-color:", ";border-color:", ";p{color:", ";}&:hover{background-color:", ";border-color:", ";p{color:", ";}}"], customStyle.background, customStyle.borderColor, customStyle.color, customStyle.hoverBg, customStyle.hoverBorderColor, customStyle.hoverColor), !outline & buttonType !== 'link' && ((_coreTheme$button$dis = coreTheme.button.disabled) === null || _coreTheme$button$dis === void 0 ? void 0 : _coreTheme$button$dis.background), (_coreTheme$button$dis2 = coreTheme.button.disabled) === null || _coreTheme$button$dis2 === void 0 ? void 0 : _coreTheme$button$dis2.borderColor, (_coreTheme$button$dis3 = coreTheme.button.disabled) === null || _coreTheme$button$dis3 === void 0 ? void 0 : _coreTheme$button$dis3.color, Config.media.md(_templateObject(), coreTheme.button.mdMinWidth, coreTheme.button.mdMinHeight, coreTheme.button.mdPadding, coreTheme.button.mdFontSize), loadingStatus === buttonStatus.SUCCESS && css(["background-color:", ";"], coreTheme.cl_successGreen), (loadingStatus === buttonStatus.IN_PROGRESS || loadingStatus === buttonStatus.SUCCESS) && css(["pointer-events:none;"]));
}));
export default Button;